<template>
    <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                           :titleLabel="$t('profile.label.fido.authentication.alert')"
                           :parentScreen="parentScreen">
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.fido.authentication.alert.main.mail')}}</label>
            <div class="col-md-6">
                <div class="checkboxThree">
                    <input type="checkbox"
                           @change="changeAuthenticateAlert()"
                           v-model="$v.input['amsCustomerDetail.authenticateAlertMainMail'].$model"
                           name="authenticateAlertMainMail"
                           true-value="1"
                           false-value="0"
                           id="ckAlertPass2MainMail">
                    <label for="ckAlertPass2MainMail"></label>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-3 col-form-label">{{$t('profile.label.fido.authentication.alert.additional.mail')}}</label>
            <div class="col-md-6">
                <div class="checkboxThree">
                    <input type="checkbox"
                           @change="changeAuthenticateAlert()"
                           v-model="$v.input['amsCustomerDetail.authenticateAlertAdditionalMail'].$model"
                           name="authenticateAlertAdditionalMail"
                           :disabled="!hasAdditionEmail"
                           true-value="1"
                           false-value="0"
                           id="ckAlertPass2AdditionalMail">
                    <label for="ckAlertPass2AdditionalMail"></label>
                </div>
            </div>
        </div>
        <template v-if="this.isParentScreenEditProfile">
            <div class="form-action">
                <button class="btn btn-sm btn-submit btn-success mr-2"
                        :disabled="isDisabledButtonSubmit"
                        :type="this.getButtonType()">
                    {{$t('profile.label.screen.2fa.save')}}
                </button>
                <button class="btn btn-sm btn-default btn-cancel"
                        type="button"
                        @click="reverseInput">
                    {{$t('btn.cancel')}}
                </button>
            </div>
        </template>
    </ForceNewsBlockWrapper>
</template>
<script>

    import formMixin from '@/common/mixins/form';
    import forceNewUtil from "@/common/mixins/forceNewUtil";
    import {createNamespacedHelpers} from 'vuex';
    import * as EDIT_PROFILE_TYPE from '@/store/modules/edit-profile/type';

    const {mapActions} = createNamespacedHelpers("editProfile");
    export default {
        name: "AuthenticateAlert",
        mixins: [formMixin, forceNewUtil],
        data() {
            return {}
        },
        validations() {
            return {
                input: {
                    'amsCustomerDetail.authenticateAlertMainMail': {},
                    'amsCustomerDetail.authenticateAlertAdditionalMail': {}
                },
            }
        },
        computed: {
            hasAdditionEmail() {
                return this.$store.state[this.namespace].hasAdditionEmail;
            }
        },
        mounted() {
        },
        methods: {
            ...mapActions([EDIT_PROFILE_TYPE.GET_ALERT_PASS2_FAIL]),
            changeAuthenticateAlert() {
                this[EDIT_PROFILE_TYPE.GET_ALERT_PASS2_FAIL](this.input);
            }
        }
    }
</script>

<style scoped>

</style>
